export default "__VITE_ASSET__BZcmbBRC__"